import * as Sentry from "@sentry/astro";
import { redactBreadcrumb, redactSentryEvent } from "./src/lib/public-routes";

// Session Replay records the page URL and bypasses beforeSend, so it never runs on the
// no-login inspector page, whose URL carries the link token.
const onInspectorPage = typeof location !== "undefined" && /^\/inspect\//i.test(location.pathname);

Sentry.init({
  dsn: "https://61e0aa526ecdf8d8b36bda002dd4f165@o4510047593431040.ingest.us.sentry.io/4512300707545088",
  // Don't report from `astro dev` — local dev errors (e.g. Vite module-runner
  // WASM-compile rejections) were polluting the prod project, mislabelled
  // "production" because environment was unset. Gate on the build mode.
  enabled: import.meta.env.PROD,
  environment: import.meta.env.MODE,
  integrations: onInspectorPage
    ? [Sentry.browserTracingIntegration()]
    : [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: onInspectorPage ? 0 : 1.0,
  sendDefaultPii: false, // never attach cookies (Clerk session), auth headers or IPs — audit M2
  // Inspector link tokens sit in the URL path; never send them.
  beforeSend: (event) => redactSentryEvent(event),
  beforeSendTransaction: (event) => redactSentryEvent(event),
  beforeBreadcrumb: (crumb) => redactBreadcrumb(crumb),
});
